import { memo } from 'react';
import { Card, CardContent, Stack, Box, Typography, Avatar } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

const ContactCard = memo(({ icon: Icon, title, subtitle, color, onClick }) => (
  <Card
    elevation={0}
    sx={{
      borderRadius: 3,
      border: '1px solid #e0e0e0',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        borderColor: color,
        boxShadow: `0 4px 12px ${color}15`,
        transform: 'translateY(-2px)',
      },
    }}
    onClick={onClick}
  >
    <CardContent>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Avatar
          sx={{
            bgcolor: `${color}15`,
            color: color,
            width: 48,
            height: 48,
          }}
        >
          <Icon />
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body1" fontWeight={600}>
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
        <ArrowForward sx={{ color: '#bdbdbd' }} />
      </Stack>
    </CardContent>
  </Card>
));

ContactCard.displayName = 'ContactCard';

export default ContactCard;
